import {
	AppBar,
	Button,
	Card,
	Dialog,
	DialogActions,
	DialogContent,
	Divider,
	IconButton,
	Toolbar,
	Typography,
} from '@mui/material'
import Transition from './Transition'
import CloseIcon from '@mui/icons-material/Close'
import { PopupListType } from 'constants/types'
import Grid from '@mui/material/Grid'

type NoticePopupProps = {
	popupIsOpen: boolean
	popupClose: () => void
	popupList: PopupListType[]
	notShowToday: () => void
}

// 공지 팝업 컴포넌트
const NoticePopup: React.FC<NoticePopupProps> = ({
	popupIsOpen,
	popupClose,
	popupList,
	notShowToday,
}) => {
	// popupList가 1건이면 0번째의 title 출력, 다건이면 0번째 title에 '외 n건' 출력
	const getTitle = () => {
		if (popupList.length === 1) {
			return popupList[0].title
		}
		return `${popupList[0].title} 외 ${popupList.length - 1}건`
	}

	return (
		<Dialog
			open={popupIsOpen}
			onClose={popupClose}
			maxWidth="lg"
			slots={{
				transition: Transition,
			}}
		>
			<AppBar sx={{ position: 'sticky' }}>
				<Toolbar>
					<Typography
						sx={{ flex: 1 }}
						variant="h6"
						component="div"
					>
						{getTitle()}
					</Typography>
					<IconButton
						edge="end"
						color="inherit"
						onClick={popupClose}
						aria-label="close"
					>
						<CloseIcon />
					</IconButton>
				</Toolbar>
			</AppBar>
			<DialogContent>
				<Grid
					container
					spacing={2}
				>
					{popupList.map((popup: PopupListType) => (
						<Grid
							size={popupList.length > 1 ? 6 : 12}
							key={popup.id}
						>
							<Card
								elevation={2}
								sx={{ p: 2, height: '100%' }}
							>
								<Typography
									gutterBottom
									variant="h5"
									component="div"
								>
									{popup.title}
								</Typography>
								<Divider />
								<Typography
									variant="body2"
									sx={{ color: 'text.secondary' }}
									dangerouslySetInnerHTML={{ __html: popup.content }}
								></Typography>
							</Card>
						</Grid>
					))}
				</Grid>
			</DialogContent>
			<Divider />
			<DialogActions sx={{ justifyContent: 'space-between' }}>
				<Button
					color="secondary"
					variant="contained"
					onClick={notShowToday}
				>
					오늘 하루 보지 않기
				</Button>
				<Button
					onClick={popupClose}
					color="primary"
					variant="contained"
				>
					닫기
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default NoticePopup
